<template>
  <div class="pa-health">
    <p class="section-intro">Answer the health questions below before continuing.</p>

    <div class="q-block">
      <p class="q-title">1. General health</p>
      <p class="q-text">Are you in good health and free from physical and mental infirmity?</p>
      <div class="yes-no">
        <label class="choice-chip" :class="{ active: health.goodHealth === 'yes' }">
          <input :checked="health.goodHealth === 'yes'" type="radio" value="yes" @change="update('goodHealth', 'yes')">
          <span>Yes</span>
        </label>
        <label class="choice-chip" :class="{ active: health.goodHealth === 'no' }">
          <input :checked="health.goodHealth === 'no'" type="radio" value="no" @change="update('goodHealth', 'no')">
          <span>No</span>
        </label>
      </div>
      <div v-if="health.goodHealth === 'no'" class="detail-field">
        <label class="detail-label">If no, provide details</label>
        <v-textarea
          :value="health.goodHealthDetails"
          outlined
          dense
          auto-grow
          rows="2"
          hide-details
          placeholder="Describe any relevant health conditions"
          class="pa-textarea"
          background-color="#FFFFFF"
          @input="update('goodHealthDetails', $event)"
        />
      </div>
    </div>

    <div class="q-block">
      <p class="q-title">2. Medical conditions</p>
      <p class="q-text">Have you been treated for diabetes, liver disease, drug abuse, spine disease, abnormal blood pressure, mental condition, alcoholism, or nervous condition?</p>
      <div class="yes-no">
        <label class="choice-chip" :class="{ active: health.medicalConditions === 'no' }">
          <input :checked="health.medicalConditions === 'no'" type="radio" value="no" @change="update('medicalConditions', 'no')">
          <span>No</span>
        </label>
        <label class="choice-chip" :class="{ active: health.medicalConditions === 'yes' }">
          <input :checked="health.medicalConditions === 'yes'" type="radio" value="yes" @change="update('medicalConditions', 'yes')">
          <span>Yes</span>
        </label>
      </div>
      <div v-if="health.medicalConditions === 'yes'" class="detail-field">
        <label class="detail-label">If yes, please explain</label>
        <v-textarea
          :value="health.medicalConditionsDetails"
          outlined
          dense
          auto-grow
          rows="2"
          hide-details
          placeholder="Provide details of any relevant conditions"
          class="pa-textarea"
          background-color="#FFFFFF"
          @input="update('medicalConditionsDetails', $event)"
        />
      </div>
    </div>

    <div class="q-block">
      <p class="q-title">3. Accident history</p>
      <p class="q-text">Particulars of accidents sustained in the last 5 years</p>
      <div class="detail-field">
        <v-textarea
          :value="health.accidentHistory"
          outlined
          dense
          auto-grow
          rows="3"
          hide-details
          placeholder="None / describe..."
          class="pa-textarea"
          background-color="#FFFFFF"
          @input="update('accidentHistory', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaHealthDeclaration',
  props: {
    health: { type: Object, required: true },
  },
  methods: {
    update(field, value) {
      this.$emit('update:health', { ...this.health, [field]: value });
    },
  },
};
</script>

<style scoped>
.pa-health { display: flex; flex-direction: column; gap: 12px; }
.section-intro { margin: 0; font-size: 0.82rem; color: #64748B; }
.q-block {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  background: #F8FAFC;
  padding: 14px;
}
.q-title {
  margin: 0 0 6px;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #1E4276;
}
.q-text { font-size: 0.85rem; color: #334155; margin: 0 0 10px; line-height: 1.5; }
.yes-no { display: flex; gap: 10px; flex-wrap: wrap; }
.choice-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #CBD5E1;
  border-radius: 999px;
  background: #FFFFFF;
  padding: 6px 12px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1E4276;
  cursor: pointer;
}
.choice-chip input { margin: 0; }
.choice-chip.active {
  border-color: #2BABE2;
  background: #E0F2FE;
  color: #0369A1;
}
.detail-field { margin-top: 12px; }
.detail-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
}
.pa-textarea ::v-deep .v-input__slot {
  border-radius: 8px !important;
  border-color: #CBD5E1 !important;
  min-height: 72px;
}
.pa-textarea ::v-deep textarea {
  font-size: 0.85rem;
  line-height: 1.45;
  color: #1E293B;
  padding-top: 10px !important;
}
</style>
